/* import CountUp from 'countup.js'; */

/* Tmp countup js */
!function () { for (var t = 0, i = ["webkit", "moz", "ms", "o"], a = 0; a < i.length && !window.requestAnimationFrame; ++a)window.requestAnimationFrame = window[i[a] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[i[a] + "CancelAnimationFrame"] || window[i[a] + "CancelRequestAnimationFrame"]; window.requestAnimationFrame || (window.requestAnimationFrame = function (i) { var a = (new Date).getTime(), n = Math.max(0, 16 - (a - t)), s = window.setTimeout(function () { return i(a + n) }, n); return t = a + n, s }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (t) { clearTimeout(t) }) }(); var __assign = this && this.__assign || function () { return (__assign = Object.assign || function (t) { for (var i, a = 1, n = arguments.length; a < n; a++)for (var s in i = arguments[a]) Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]); return t }).apply(this, arguments) }, CountUp = function () { function t(t, i, a) { var n = this; this.target = t, this.endVal = i, this.options = a, this.version = "2.0.4", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "" }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.count = function (t) { n.startTime || (n.startTime = t); var i = t - n.startTime; n.remaining = n.duration - i, n.useEasing ? n.countDown ? n.frameVal = n.startVal - n.easingFn(i, 0, n.startVal - n.endVal, n.duration) : n.frameVal = n.easingFn(i, n.startVal, n.endVal - n.startVal, n.duration) : n.countDown ? n.frameVal = n.startVal - (n.startVal - n.endVal) * (i / n.duration) : n.frameVal = n.startVal + (n.endVal - n.startVal) * (i / n.duration), n.countDown ? n.frameVal = n.frameVal < n.endVal ? n.endVal : n.frameVal : n.frameVal = n.frameVal > n.endVal ? n.endVal : n.frameVal, n.frameVal = Math.round(n.frameVal * n.decimalMult) / n.decimalMult, n.printValue(n.frameVal), i < n.duration ? n.rAF = requestAnimationFrame(n.count) : null !== n.finalEndVal ? n.update(n.finalEndVal) : n.callback && n.callback() }, this.formatNumber = function (t) { var i, a, s, e, r, o = t < 0 ? "-" : ""; if (i = Math.abs(t).toFixed(n.options.decimalPlaces), s = (a = (i += "").split("."))[0], e = a.length > 1 ? n.options.decimal + a[1] : "", n.options.useGrouping) { r = ""; for (var l = 0, u = s.length; l < u; ++l)0 !== l && l % 3 == 0 && (r = n.options.separator + r), r = s[u - l - 1] + r; s = r } return n.options.numerals && n.options.numerals.length && (s = s.replace(/[0-9]/g, function (t) { return n.options.numerals[+t] }), e = e.replace(/[0-9]/g, function (t) { return n.options.numerals[+t] })), o + n.options.prefix + s + e + n.options.suffix }, this.easeOutExpo = function (t, i, a, n) { return a * (1 - Math.pow(2, -10 * t / n)) * 1024 / 1023 + i }, this.options = __assign({}, this.defaults, a), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(i), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.decimalMult = Math.pow(10, this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof t ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined" } return t.prototype.determineDirectionAndSmartEasing = function () { var t = this.finalEndVal ? this.finalEndVal : this.endVal; this.countDown = this.startVal > t; var i = t - this.startVal; if (Math.abs(i) > this.options.smartEasingThreshold) { this.finalEndVal = t; var a = this.countDown ? 1 : -1; this.endVal = t + a * this.options.smartEasingAmount, this.duration = this.duration / 2 } else this.endVal = t, this.finalEndVal = null; this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing }, t.prototype.start = function (t) { this.error || (this.callback = t, this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal)) }, t.prototype.pauseResume = function () { this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused }, t.prototype.reset = function () { cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal) }, t.prototype.update = function (t) { cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal || this.resetDuration(), this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) }, t.prototype.printValue = function (t) { var i = this.formattingFn(t); "INPUT" === this.el.tagName ? this.el.value = i : "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = i : this.el.innerHTML = i }, t.prototype.ensureNumber = function (t) { return "number" == typeof t && !isNaN(t) }, t.prototype.validateValue = function (t) { var i = Number(t); return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: " + t, null) }, t.prototype.resetDuration = function () { this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration }, t }(); export { CountUp };

$(function () {

  /**
   * Annual Report 2019
   */
  if ($('#annual-report').length) {
    drawLines(document.getElementById('a'));
    drawLines(document.getElementById('b'));
    drawLines(document.getElementById('c'));
    drawLines(document.getElementById('d'));
    drawLines(document.getElementById('e'));

    drawLines(document.getElementById('1a'));
    drawLines(document.getElementById('1b'));
    drawLines(document.getElementById('2'));
    drawLines(document.getElementById('3'));
    drawLines(document.getElementById('4'));
  }

  /**
   * Annual Report 2020
   */
  if ($('#annualreport2020').length) {

    var windowWidth = $(window).width();

    $(window).resize(function () {
      windowWidth = $(window).width();
    });

    if (windowWidth > 991) {
      drawLines(document.getElementById('1a'));
      drawLines(document.getElementById('1b'));
      drawLines(document.getElementById('2a'));
      drawLines(document.getElementById('2b'));
    } else {
      drawLines(document.getElementById('1a-m'));
      drawLines(document.getElementById('1b-m'));
      drawLines(document.getElementById('2a-m'));
      drawLines(document.getElementById('2b-m'));
    }
  }

  /**
   * Campaign module - Highlights
   */
  const campaignHighlights = document.querySelectorAll('.campaign-timeline');
  if (campaignHighlights.length) {
    for (const item of campaignHighlights) {
      const lines = item.querySelectorAll('svg.line path');
      for (const line of lines) {
        drawLines(line);
      }
    }
  }

  function drawLine(el, percent) {
    let length = Math.floor(el.getTotalLength());

    el.style.strokeDasharray = length;
    el.style.strokeDashoffset = length * (1 - percent);
  }

  function drawLines(el) {
    let length = Math.floor(el.getTotalLength());

    el.style.strokeDashoffset = length;
    el.style.strokeDasharray = length + ' ' + (length * 2);

    let scroll = window.requestAnimationFrame || (callback => window.setTimeout(callback, 1000 / 60));

    (function loop() {

      let rect = el.getBoundingClientRect();

      let middleWindow = document.documentElement.clientHeight * 0.8;

      let topY = Math.max(0, middleWindow - rect.top);

      let percent = Math.min(1, topY / rect.height);

      drawLine(el, percent);
      return scroll(loop);
    })();
  }
});

function isElementVisible(el) {
  let rect = el.getBoundingClientRect();
  return rect.top <= 0 || rect.top <= ((window.innerHeight || document.documentElement.clientHeight)) * 0.7;
}


$(window).on('scroll', function () {
  let animateBlock = document.querySelectorAll('.animate-block');
  animateBlock.forEach(el => {
    if (isElementVisible(el)) {
      el.classList.add('animated');
    } else {
      el.classList.remove('animated');
    }

  })
})


/* Counters */
window.onload = function () {

  var counters = document.querySelectorAll('.countup');
  counters.forEach(el => {
    var visibleCounter = false;
    let currentCounter = el;

    if (isElementVisible(el) && !visibleCounter) {
      counterInit(currentCounter, true);
      visibleCounter = true;
    } else {
      counterInit(currentCounter, false);
    }

    $(window).on('scroll', function () {

      if (isElementVisible(el) && !visibleCounter) {
        counterInit(currentCounter, true);
        visibleCounter = true;
      } else if (!isElementVisible(el) && (visibleCounter == true)) {
        visibleCounter = false;
      }
    })

  })

  function counterInit(el, callbackoption) {
    let current = el;
    let countFrom = current.dataset.countFrom;
    let countTo = current.dataset.countTo;

    const options = {
      startVal: countFrom,
      duration: 2,
      separator: '.',
      decimal: ',',
      decimalPlaces: 0
    };

    /* console.log(options); */
    let countUp = new CountUp(current, countTo, options);

    current.classList.add('active');

    if (!countUp.error) {
      countUp.reset();
      countUp.start();
    } else {
      console.error(countUp.error);
    }

    if (callbackoption == true) {
      if (!countUp.error) {
        countUp.reset();
        countUp.start();
      } else {
        console.error(countUp.error);
      }
    } else {
      countUp.reset();
    }


  }
}

/* AR 2022 */
document.addEventListener("DOMContentLoaded", () => {

  const expandBtn = document.querySelectorAll('.js-expand');
  const expandCloseBtn = document.querySelectorAll('.js-expand-close');
  const exHolders = document.querySelectorAll('.ex-section');
  const exImgs = document.querySelectorAll('.ex-img');

  if (expandBtn) {

    expandBtn.forEach(el => {

      el.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        let parent = el.parentNode.closest('.js-ex-holder');
        parent.classList.add('expanded-content');
      })
    })

    expandCloseBtn.forEach(el => {

      el.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        let parent = el.parentNode.closest('.js-ex-holder');
        parent.classList.remove('expanded-content');
        exImgs.forEach(img => {
          img.classList.remove('visible');
        })

        el.parentNode.closest('.expandable_content').scrollIntoView();
      })
    })
  }

  const exObserverCallback = (exesToWatch, exObserver) => {
    if (exesToWatch[0].isIntersecting) {

      exImgs.forEach(img => {
        if (img.dataset.imgurl == exesToWatch[0].target.dataset.imgurl) {
          img.classList.add('visible');
        }
      })

    } else {

      exImgs.forEach(img => {
        if (img.dataset.imgurl == exesToWatch[0].target.dataset.imgurl) {
          img.classList.remove('visible');
        }
      })

    }
  }

  const exObserverOptions = {
    rootMargin: '0px 0px -40%'
  }

  const exObserver = new IntersectionObserver(exObserverCallback, exObserverOptions);

  exHolders.forEach(ex => {
    exObserver.observe(ex);
  })
});

/* AR 2023 */
document.addEventListener("DOMContentLoaded", () => {

  const arProgressBar = document.getElementById('arBar');
  const footer = document.querySelector('footer');
  const footerHeight = footer.offsetHeight;

  if (arProgressBar) {
    window.onscroll = function () { myFunction() };

    function myFunction() {
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      var height = document.documentElement.scrollHeight - document.documentElement.clientHeight - footerHeight;
      var scrolled = (winScroll / height) * 100;
      arProgressBar.style.width = scrolled + "%";
    }
  }

  //Active links
  const progressContainer = document.querySelectorAll('.progress-container');

  if (progressContainer) {
    const links = document.querySelectorAll('.progress-bar-anchor-link');

    function isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight - footerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function onScroll() {
      links.forEach(function (link) {
        var targetId = link.getAttribute('href').substring(1);
        var targetElement = document.getElementById(targetId);

        if (targetElement) {
          if (isElementInViewport(targetElement)) {
            links.forEach(function (link) {
              link.classList.remove('active');
            });
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        }

      });
    }

    window.addEventListener('scroll', onScroll);
    window.addEventListener('load', onScroll);
  }

  //Progress and Challenges color animation
  const articles = document.querySelectorAll('.progress_and_challenges__articles-section article.animate');

  if (articles) {
    function changeArticleColor(scrollPosition) {
      articles.forEach((article, index) => {
        const color = article.getAttribute('data-color');

        const offsetTop = article.offsetTop;

        if (offsetTop - scrollPosition <= 500) {
          article.style.backgroundColor = color;

          // Apply the color to all articles below
          for (let i = index + 1; i < articles.length; i++) {
            articles[i].style.backgroundColor = color;
          }
        }
      });
    }

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY || window.pageYOffset;

      changeArticleColor(scrollPosition);
    });
  }
})